import React, { useEffect } from "react";
import { func, string } from "prop-types";

export const HubSpotForm = ({
	formId,
	portalId,
	formSubmitFunc = () => {},
	region = "na1",
	target,
}) => {
	useEffect(() => {
		const script = document.createElement("script");
		script.src = "//js.hsforms.net/forms/v2.js";
		script.type = "text/javascript";
		script.async = true;
		script.onload = () => {
			const hubspotForms = window.hbspt.forms.create;
			hubspotForms({
				portalId,
				region,
				formId,
				target: `#${target}`,
				onFormSubmitted: formSubmitFunc,
			});
		};

		document.body.appendChild(script);
	}, []);

	return React.createElement("div", { id: target });
};

HubSpotForm.propTypes = {
	formId: string.isRequired,
	portalId: string.isRequired,
	region: string,
	target: string.isRequired,
	formSubmitFunc: func,
};
